import { render, staticRenderFns } from "./Destinatarios.vue?vue&type=template&id=55e6862c&scoped=true&"
import script from "./Destinatarios.vue?vue&type=script&lang=ts&"
export * from "./Destinatarios.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e6862c",
  null
  
)

export default component.exports